import React from "react";
import Page from "../../components/DefaultPage/DefaultPage";
import { useTranslation } from "react-i18next";
import ValidationBox from "../../components/ValidationBox/ValidationBox";

export default function VerifyCode() {
  const landpage = true;
  const [tg] = useTranslation("global");
  return (
    <Page landpage={false}>
      <ValidationBox />

    </Page>
  );
}
